import {
  GETBUSINESSNATUREMAPPINGLIST_SUCCESS,
  GETBUSINESSNATUREMAPPINGLIST_FAILED,
  RESET_GETBUSINESSNATUREMAPPINGLIST,
  LOADING_GETBUSINESSNATUREMAPPINGLIST,
  NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETBUSINESSNATUREMAPPINGLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATUREMAPPINGLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATUREMAPPINGLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETBUSINESSNATUREMAPPINGLIST:
      return (state = initialState);
    default:
      return state;
  }
};
